// componente per la visualizzazione e gestione della tabella contenente tutti i pannelli (componente destra)
// nella pagina "Pannelli"

import { Component, ViewChild, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { PlantsService } from '../plants.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';;
import { Plants } from '../plants.model';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from '../../../../service/authentication.service';
import { UtilsService } from '../../../../service/helper/utils.service';
import { PlantsComponent } from '../plants.component';
import { ApiService } from '../../../../service/api.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-plants-list',
  templateUrl: './plants-list.component.html',
  styleUrls: ['style.scss']
})
export class PlantsListComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private subscription: Subscription;

  // inizializzazione array con tutti i pannelli da mostrare nella tabella
  dataSource: MatTableDataSource<Plants>;

  // inizializzazione id, profilo e array con tutti gli indici dei messaggi nella tabella
  public id: number
  profile: string
  index = []
  groupids = []
  groupid
  bodies = []
  tags = []
  public refresh: Subject<any> = new Subject();
  filterValues = {};
  filterSelectObj = [];

  viewDate: Date = new Date();

  events$: Plants[];
  events: Plants[];
  // colonne da mostrare nella tabella (ciascuna etichetta è definita nella pagina html)
  displayedColumns: string[] = ['plantid', 'alias', 'groupid', 'name', 'enabled', 'address', 'latitude', 'longitude', 'modem', 'email', 'planttype', 'bodyid', 'tag', 'actions', 'reset'];

  constructor(public utils: UtilsService, public plantsComponent: PlantsComponent, private authenticationService: AuthenticationService, private plantsService: PlantsService,
    private changeDetectorRefs: ChangeDetectorRef, private utilsService: UtilsService, private storageService: ApiService) {
    this.filterSelectObj = [
      {
        name: 'ID impianto',
        columnProp: 'plantid',
        options: []
      }, {
        name: 'Alias',
        columnProp: 'alias',
        options: []
      }, {
        name: 'ID gruppo/i',
        columnProp: 'groupid',
        options: []
      }, {
        name: 'Nome',
        columnProp: 'name',
        options: []
      }, {
        name: 'Abilitato',
        columnProp: 'enabled',
        options: []
      },{
        name: 'Indirizzo',
        columnProp: 'address',
        options: []
      },  {
        name: 'Latitudine',
        columnProp: 'latitude',
        options: []
      },{
        name: 'Longitudine',
        columnProp: 'longitude',
        options: []
      }, {
        name: 'Modem',
        columnProp: 'modem',
        options: []
      }, {
        name: 'Email',
        columnProp: 'email',
        options: []
      }, {
        name: 'Tipo impianto',
        columnProp: 'planttype',
        options: []
      },{
        name: 'ID ente',
        columnProp: 'bodyid',
        options: []
      },  {
        name: 'Tag',
        columnProp: 'tag',
        options: []
      },
    ]


  }

  // metodi necessari per aggiornare la tabella in seguito ad interazioni (modifiche, aggiunte, cancellazioni)
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();

  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = this.createFilter();
  }
  // metodo utilizzato per abilitare il filtraggio nella tabella
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnInit(): void {
    this.getData();
    this.plantsService.refresh$.subscribe(res => {
      this.getData();
    })
  }
  getData() {
    var me = this

    me.utils.showLoader()

    // si imposta il profilo corrente
    this.profile = this.authenticationService.currentUserValue.profile

    // si richiede all'apposito servizio la lista di pannelli e si popola la tabella, applicandone le opportune opzioni
    // (dal paginator, al sort)
    this.dataSource = new MatTableDataSource(this.plantsService.getPlants());
    this.subscription = this.plantsService.plantsChanged.subscribe(
      (plantss: Plants[]) => {
        this.dataSource = new MatTableDataSource(plantss);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento

        this.dataSource.filterPredicate = this.createFilter();
        this.filterSelectObj.filter((o) => {
          o.options = this.getFilterObject(this.plantsService.getPlants(), o.columnProp);
        });
        this.changeDetectorRefs.detectChanges();
        this.resetFilters()
      }
    );
  }


  isEdit() {
    return this.plantsComponent.isedit
  }
  change() {
    this.plantsComponent.isedit = !this.plantsComponent.isedit
  }
  // metodo richiamato al click del pulsante "modifica" in una riga della tabella
  onEdit(val) {
    var id = val.id
    this.plantsService.editPlants(id);
    this.change()
  }

  // metodo richiamato alla chiusura della pagina "Pannelli"
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // metodo richiamato dalla componente "PanelEdit": permette di riempire la form di modifica messaggio con tutti i dati
  // relativi al messaggio il cui ID viene indicato in ingresso
  getIndex(ids) {
    this.dataSource = new MatTableDataSource(this.plantsService.getPlants());
    this.index = []
    for (var i = 0; i < this.dataSource.filteredData.length; i++) {
      this.index.push({
        "id": this.dataSource.filteredData[i].id,
        "edit": i
      })
    }
    var result = this.index.find(obj => {
      return obj.id == ids
    })
    return result.edit
  }

  filterChange(filter, event) {
    //let filterValues = {}
    if (filter.columnProp == "enabled") {
      event.target.value == "No" ? this.filterValues[filter.columnProp] = false : this.filterValues[filter.columnProp] = true
    } else if (filter.columnProp == "latitude" || filter.columnProp == "longitude") {
      this.filterValues[filter.columnProp] = parseFloat(event.target.value)
    } else
    this.filterValues[filter.columnProp] = event.target.value

    this.dataSource.filter = JSON.stringify(this.filterValues)
  }

  // Custom filter method fot Angular Material Datatable
  createFilter() {
    let filterFunction = function (data: any, filter: string): boolean {
      let searchTerms = JSON.parse(filter);

      var found = 0
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '') {
          if (data[col] === searchTerms[col]) {
            found++
          }

        } else {
          delete searchTerms[col];
        }
      }
      return found == Object.keys(searchTerms).length
    }
    return filterFunction
  }


  // Reset table filters
  resetFilters() {
    this.filterValues = {}
    this.filterSelectObj.forEach((value, key) => {
      value.modelValue = undefined;
    })
    this.dataSource.filter = "";
  }
  getFilterObject(fullObj, key) {
    const uniqChk = [];
    fullObj.filter((obj) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    var ret = []
    if (key == 'enabled') {
      ret = ["Si", "No"]
    } else {
      ret = uniqChk.sort()
    }
    return ret;
  }

  downloadFile(data, filename = 'data') {
    let csvData = this.ConvertToCSV(data, ['plantid', 'alias', 'groupid', 'name', 'enabled', 'address', 'latitude', 'longitude', 'modem', 'email', 'planttype', 'bodyid', 'tag']);

    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  ConvertToCSV(objArray, headerList) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    array.forEach(function (v) {
      delete v.id
      delete v.timestamp
    });
    let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(",")}` + '\r\n';
    return array.reduce((str, next) => {
      str += `${Object.values(next).map(value => `"${value}"`).join(",")}` + '\r\n';
      return str.replace(/['"]+/g, '');
    }, str.replace(/['"]+/g, ''));
  }
  download() {
    this.downloadFile(this.plantsService.getPlants(), 'impianti');
  }
}
